/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-escape */
import { useEffect, useState, useCallback } from "react";
import { FaCheck } from "react-icons/fa6";
import { FaRegComment } from "react-icons/fa6";
import { BsFillSendFill } from "react-icons/bs";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import { MdEdit } from "react-icons/md";
import axios from "axios";
import { debounce } from "lodash";
import { toast } from "react-toastify";
import { IoIosEye } from "react-icons/io";
import { IoIosEyeOff } from "react-icons/io";
import "react-toastify/dist/ReactToastify.css";
import socket from "../../services/socket";

const TextZone = ({
  trans,
  setAllTextsValid,
  setSelectedTrans,
  setPageValidated,
  allTextsValid,
  loggedUser,
  setValidationPage,
  currentTome,
  relatedSerie,
  group,
  pageHasComment,
  unvalidatePage,
}) => {
  console.log("trans : ", trans);
  console.log("text zone conponent : ", trans?.sous_images);
  let transText = trans.sous_images;

  const [textChanged, setTextChanged] = useState("");
  const [validationText, setValidationText] = useState("Validate Page");
  const [addComment, setAddComment] = useState(false);
  // const [comments, setComments] = useState();
  const [isSending, setIsSending] = useState(false);
  // const [isUpdated, setIsUpdated] = useState("");
  const [textTranslated, setTextTranslated] = useState([...trans.sous_images]);
  const [textTranslatedNew, setTextTranslatedNew] = useState(null);
  const [updateThisComment, setUpdateThisComment] = useState(null);
  const [deleteThisComment, setDeleteThisComment] = useState(null);
  const [selectedIdx, setSelectedIdx] = useState(null);
  const [showStroke, setShowStroke] = useState(false);
  const [allTextsAreValid, setAllTextsAreValid] = useState(false);
  const [shadowStyle, setShadowStyle] = useState({});
  const [transTextObject, setTransTextObject] = useState({ ...trans });

  const checkValidationOfTexts = (selectedPageObj) => {
    let selectedPage = selectedPageObj.sous_images;
    let allTexts = 0;
    if (selectedPage.length !== 0) {
      for (let i = 0; i < selectedPage.length; i++) {
        if (selectedPage[i]?.traduction_validee === true) {
          allTexts++;
        } else {
          setAllTextsAreValid(false);
          break;
        }
      }
      if (selectedPage.length === allTexts) {
        setAllTextsAreValid(true);
        validateThisPage();
      }
    }
  };

  // useEffect( () => {
  //   checkValidationOfTexts(textTranslated);
  // }, [textTranslated, textTranslatedNew])

  // Debounced function to update data in the database
  const updateDataInDatabase = useCallback(
    debounce((selectedIdx) => {
      if (selectedIdx !== null) {
        console.log(
          "wow : ",
          document.getElementById(`updateText-${selectedIdx}`)
        );
        document.getElementById(`updateText-${selectedIdx}`).click();
      }
    }, 500), // Adjust the debounce delay as needed (1s in this case)
    []
  );

  // Effect to run when `data` state changes
  useEffect(() => {
    if (selectedIdx !== null) {
      updateDataInDatabase(selectedIdx);
    }
  }, [textChanged, updateDataInDatabase]);

  //   console.log('after for loop : ', transText)
  console.log("textTranslated : ", textTranslated);
  // console.log('get comments : ', comments)

  useEffect(() => {
    setTextTranslated(trans.sous_images);
    // getComments(textTranslated);
  }, [trans]);

  const showComments = (e) => {
    setAddComment(!addComment);
    let parentID =
      e.target.parentElement.id.split("-")[1] || e.target.id.split("-")[1];
    console.log("add comment parentID ", parentID);
    if (parentID) {
      // console.log(parentID)
      document
        .getElementById(`c-${parentID}`)
        .classList.toggle("commentActive");
      document.getElementById(`comment-${parentID}`).classList.toggle("d-none");
    }
  };

  const sendComment = (event, i) => {
    const commentValue = document.getElementById(`comment-${i}-value`).value;
    // console.log(event.target);
    const token = localStorage.getItem("login_token");
    if (token) {
      if (commentValue !== "") {
        let coordId = textTranslated[i].id_sous_image;
        let id_page = transTextObject.id_page;
        setIsSending(true);
        document.getElementById(`send-comment-${i}`).classList.add("dis-none");
        document
          .getElementById(`send-comment-spin-${i}`)
          .classList.remove("dis-none");
        let body = {
          commentaire: commentValue,
        };
        try {
          axios
            .put(
              `${process.env.REACT_APP_HOST_API}/api/comment/from_coord/${coordId}/${id_page}`,
              body,
              {
                headers: { Authorization: token },
              }
            )
            .then((res) => {
              if (res.status === 200) {
                console.log("Comment added : ", res.data);
                let newList = [...textTranslated];
                let date = new Date();
                newList[i].comments = {
                  commentaire: commentValue,
                  commentaire_utilisateur: loggedUser.username,
                  date_commentaire: date.toISOString(),
                  commentaire_fk_utilisateur: loggedUser.id,
                };
                setTextTranslated([...newList]);
                setIsSending(false);
                pageHasComment();
                // setCommentSent(res.data)
                document.getElementById(
                  `comment-${i}-value`
                ).style.borderColor = "#463B4D";
                document
                  .getElementById(`send-comment-${i}`)
                  .classList.remove("dis-none");
                document
                  .getElementById(`send-comment-spin-${i}`)
                  .classList.add("dis-none");
                document.getElementById(`comment-${i}-value`).value = "";
                document.getElementById(`comment-${i}-value`).disabled = true;
                document.getElementById(`comment-${i}`).classList.add("d-none");
                // textUpdated(res.data);
                let action = {
                  fk_utilisateur: loggedUser.id,
                  fk_serie: currentTome.tome.fk_serie,
                  fk_tome: currentTome.tome._id,
                  contenu: `${
                    loggedUser.username
                  } has left a new comment on \"${
                    currentTome.tome.nom
                  }\" page \"${parseInt(trans?.page)}\" of the serie \"${
                    relatedSerie.titre
                  }\"`,
                  target_user: "",
                  date: date.toISOString(),
                  statut: "sent",
                };
                console.log("comment action : ", action);
                let sendTo = group.filter((el) => el._id !== loggedUser.id);
                console.log("comment sendTo : ", sendTo);
                socket.emit("validate", action, sendTo);
              }
            });
        } catch (error) {
          console.log(error);
        }
      } else {
        document.getElementById(`comment-${i}-value`).style.borderColor =
          "orangered";
        toast.error("Can't send empty comments");
      }
    }
  };

  const sendUpdatedComment = (event, i) => {
    const commentValue = document.getElementById(
      `update-comment-${i}-value`
    ).value;
    // console.log(event.target);

    const token = localStorage.getItem("login_token");
    if (token && transText) {
      if (commentValue !== "") {
        setIsSending(true);
        let text_id = transText[i].text_id;
        document
          .getElementById(`send-update-comment-${i}`)
          .classList.add("dis-none");
        document
          .getElementById(`send-update-comment-spin-${i}`)
          .classList.remove("dis-none");
        let body = {
          commentaire: commentValue,
          text_id: text_id,
        };
        console.log("Comment updated body : ", body);
        try {
          axios
            .put(
              `${process.env.REACT_APP_HOST_API}/api/comment/update-comment`,
              body,
              {
                headers: { Authorization: token },
              }
            )
            .then((res) => {
              if (res.status === 200) {
                console.log("Comment updated : ", res.data);
                // setCommentSent(res.data)
                let newList = [...textTranslated];
                let oldObj = {
                  ...newList[i].comments,
                  commentaire: commentValue,
                };
                newList[i].comments = oldObj;
                setTextTranslated([...newList]);
                setIsSending(false);
                document.getElementById(
                  `update-comment-${i}-value`
                ).style.borderColor = "#463B4D";
                document
                  .getElementById(`send-update-comment-${i}`)
                  .classList.remove("dis-none");
                document
                  .getElementById(`send-update-comment-spin-${i}`)
                  .classList.add("dis-none");
                document.getElementById(`update-comment-${i}-value`).value = "";
                document.getElementById(`comments_exist_${i}`).style.display =
                  "block";
                document
                  .getElementById(`update-comment-${i}`)
                  .classList.add("d-none");
                toast.success(res.data.message);
              }
            });
        } catch (error) {
          setIsSending(false);
          console.log("Comment err : ", error);
          toast.error(error.data.message);
        }
      } else {
        document.getElementById(`update-comment-${i}-value`).style.borderColor =
          "orangered";
        toast.error("Can't send empty comments");
      }
    }
  };

  const updateTextTranslated = (event, idx) => {
    let list = [...textTranslated];
    let newvalue = event.target.value;
    let obj = { ...transTextObject };
    list[idx].text_translated = newvalue;
    obj.sous_images[idx].text_translated = newvalue;
    setTextTranslated(list);
    setSelectedTrans(obj);
    setSelectedIdx(idx);
    setTextChanged(newvalue);
  };

  const updateText = (text, i) => {
    console.log("update : ", text);
    const token = localStorage.getItem("login_token");
    if (token) {
      let body = {
        translated_text: text.text_translated,
      };
      let fontSettings = {
        fontName: text.fontName,
        fontWeight: text.fontWeight,
        size: text.size,
        color: text.color,
        fontStyle: text.fontStyle,
        stroke_color: text.stroke_color,
      };

      try {
        axios
          .put(
            `${process.env.REACT_APP_HOST_API}/api/translation/${text.id_sous_image}`,
            body,
            {
              headers: { Authorization: token },
            }
          )
          .then((res) => {
            if (res.status === 200) {
              // update fonts
              try {
                axios
                  .put(
                    `${process.env.REACT_APP_HOST_API}/api/translation/font/${text.id_sous_image}`,
                    fontSettings,
                    {
                      headers: { Authorization: token },
                    }
                  )
                  .then((res) => {
                    if (res.status === 200) {
                      if (text.traduction_validee === true) {
                        unvalidateText(text, i);
                      }
                      setSelectedIdx(null);
                      console.log("res updated text : ", res);
                    }
                  });
              } catch (error) {
                console.log(error);
              }
            }
          });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const validateText = (text, i) => {
    const token = localStorage.getItem("login_token");
    if (token) {
      document.getElementById(`v-spin-${i}`).style.display = "flex";
      document.getElementById(`v-${i}`).style.display = "none";
      try {
        axios
          .put(
            `${process.env.REACT_APP_HOST_API}/api/translation/translationValidation/${text.id_sous_image}`,
            {},
            {
              headers: { Authorization: token },
            }
          )
          .then((resp) => {
            console.log("resp validated text : ", resp);
            if (resp.status === 200) {
              let newList = [...textTranslated];
              newList[i].traduction_validee = true;
              newList[i].fk_utilisateur_validation = loggedUser.username;
              let validation_date = new Date();
              newList[i].date_validation = validation_date.toISOString();
              setTextTranslated([...newList]);
              setTextTranslatedNew([...newList]);
              let coordsValid = { ...transTextObject, sous_images: newList };
              setTransTextObject({ ...coordsValid });
              setSelectedTrans({ ...coordsValid });
              checkValidationOfTexts(coordsValid);
              console.log("res of coordsValid : ", coordsValid);
              document.getElementById(`v-spin-${i}`).style.display = "none";
              document.getElementById(`v-${i}`).style.display = "flex";
              let action = {
                fk_utilisateur: loggedUser.id,
                fk_serie: currentTome.tome.fk_serie,
                fk_tome: currentTome.tome._id,
                contenu: `${
                  loggedUser.username
                } has validated new translated texts on \"${
                  currentTome.tome.nom
                }\" page \"${parseInt(trans?.page)}\" of the serie \"${
                  relatedSerie.titre
                }\"`,
                target_user: "",
                date: validation_date.toISOString(),
                statut: "sent",
              };
              console.log("zone text action : ", action);
              let sendTo = group.filter((el) => el._id !== loggedUser.id);
              console.log("zone text sendTo : ", sendTo);
              socket.emit("validate", action, sendTo);
            }
          });
      } catch (error) {
        console.log("validate this text err : ", error);
      }
    }
  };

  // unvalidate text when update it
  const unvalidateText = (text, i) => {
    const token = localStorage.getItem("login_token");
    if (token) {
      try {
        axios
          .put(
            `${process.env.REACT_APP_HOST_API}/api/translation/translationUnvalidation/${text.id_sous_image}`,
            {},
            {
              headers: { Authorization: token },
            }
          )
          .then((resp) => {
            console.log("resp validated text : ", resp);
            if (resp.status === 200) {
              let newList = [...textTranslated];
              newList[i].traduction_validee = false;
              newList[i].fk_utilisateur_validation = "";
              newList[i].date_validation = "";
              setTextTranslated([...newList]);
              setTextTranslatedNew([...newList]);
              let coordsValid = { ...transTextObject, sous_images: newList };
              setSelectedTrans({ ...coordsValid });
              setTransTextObject({ ...coordsValid });
              // transTextObject.validation = false;
              // checkValidationOfTexts(coordsValid);
              unvalidateThisPage();
            }
          });
      } catch (error) {
        console.log("validate this text err : ", error);
      }
    }
  };

  const updateFont = (event, i) => {
    let list = [...textTranslated];
    let obj = { ...transTextObject };
    let newvalue = event.target.value;
    list[i].fontName = newvalue;
    obj.sous_images[i].fontName = newvalue;
    setTextTranslated(list);
    console.log("font : ", obj);
    setSelectedTrans(obj);
    // fontChange(newvalue);
    setSelectedIdx(i);
    setTextChanged(newvalue);
  };

  const updateColor = (event, i) => {
    let list = [...textTranslated];
    let obj = { ...transTextObject };
    let newvalue = event.target.value;
    list[i].color = newvalue;
    obj.sous_images[i].color = newvalue;
    setTextTranslated(list);
    console.log("color : ", newvalue);
    setSelectedTrans(obj);
    setSelectedIdx(i);
    setTextChanged(newvalue);
  };

  const updateWeight = (event, i) => {
    let list = [...textTranslated];
    let obj = { ...transTextObject };
    let newvalue = event.target.value;
    list[i].fontWeight = newvalue;
    obj.sous_images[i].fontWeight = newvalue;
    setTextTranslated(list);
    console.log("weight : ", obj);
    setSelectedTrans(obj);
    setSelectedIdx(i);
    setTextChanged(newvalue);
    // fontChange(newvalue);
  };

  const updateSize = (event, i) => {
    // let list = [...textTranslated];
    let obj = { ...transTextObject };
    let newvalue = event.target.value;
    // list[i].fontName = newvalue;
    obj.sous_images[i].size = newvalue;
    // setTextTranslated(list);
    console.log("font : ", obj);
    setSelectedTrans(obj);
    setSelectedIdx(i);
    setTextChanged(newvalue);
    // setFonts(newvalue);
  };

  const validateThisPage = () => {
    setValidationText("Please wait...");
    console.log(trans);
    let id_page = trans.id_page;
    const token = localStorage.getItem("login_token");
    console.log("token : ", token, "id page : ", id_page);
    if (token) {
      try {
        axios
          .put(
            `${process.env.REACT_APP_HOST_API}/api/documentVO/pageValidation/${id_page}`,
            {},
            {
              headers: { Authorization: token },
            }
          )
          .then((res) => {
            console.log("res of validate page : ", res);
            if (res.status === 200) {
              console.log("validated page : ", res);
              setPageValidated(`${Math.random()}`);
              setValidationText("Page is validated");
              setValidationPage(true);
              setAllTextsValid(`${Math.random()}`);
            }
          });
      } catch (error) {
        console.log("validate page error : ", error);
      }
    }
  };

  // unvalidate page when text updated
  const unvalidateThisPage = () => {
    setValidationText("Please wait...");
    console.log(trans);
    let id_page = trans.id_page;
    const token = localStorage.getItem("login_token");
    console.log("token : ", token, "id page : ", id_page);
    if (token) {
      try {
        axios
          .put(
            `${process.env.REACT_APP_HOST_API}/api/documentVO/pageUnvalidation/${id_page}`,
            {},
            {
              headers: { Authorization: token },
            }
          )
          .then((res) => {
            console.log("res of unvalidate page : ", res);
            if (res.status === 200) {
              console.log("unvalidated : ", res);
              setPageValidated(Math.random());
              setValidationText("Page is unvalidated");
              setValidationPage(false);
              setAllTextsValid(Math.random());
              unvalidatePage();
            }
          });
      } catch (error) {
        console.log("validate page error : ", error);
      }
    }
  };

  const deleteComment = (text_id, comment_fk_user, i) => {
    const token = localStorage.getItem("login_token");
    if (token) {
      document.getElementById(`delete-spin-${i}`).style.display = "flex";
      document.getElementById(`delete-btn-${i}`).style.display = "none";
      setDeleteThisComment(i);
      console.log("Comment deleted id : ", text_id);
      console.log("Comment deleted i : ", i);
      let body = {
        text_id,
        comment_fk_user,
      };
      console.log("Comment body ", body);
      try {
        axios
          .post(
            `${process.env.REACT_APP_HOST_API}/api/comment/delete-comment`,
            body,
            {
              headers: { Authorization: token },
            }
          )
          .then((res) => {
            if (res.status === 201) {
              let newList = [...textTranslated];
              newList[i].comments = null;
              console.log("Comment newList after deleted : ", newList);
              setTextTranslated([...newList]);
              setTextTranslatedNew([...newList]);
              document.getElementById(`comment-${i}-value`).disabled = false;
              console.log("Comment deleted : ", res.data);
              // setCommentSent(res.data)
            }
          });
      } catch (error) {
        console.log("Comment delete err : ", error);
      }
    }
  };

  const updateComment = (thisComment, i) => {
    setUpdateThisComment(i);
    console.log("comment : ", thisComment, " i : ", i);
    document.getElementById(`comments_exist_${i}`).style.display = "none";
    document.getElementById(`update-comment-${i}`).classList.remove("d-none");
    document.getElementById(`update-comment-${i}-value`).value =
      thisComment.commentaire;
  };

  const changeFontStyle = (i) => {
    let thisStyle = textTranslated[i]?.fontStyle;
    let list = [...textTranslated];
    let obj = { ...transTextObject };
    setSelectedIdx(i);

    if (thisStyle === undefined || thisStyle === "italic") {
      list[i].fontStyle = "normal";
      obj.sous_images[i].fontStyle = "normal";
      setTextTranslated(list);
      console.log("style : ", obj);
      setSelectedTrans(obj);
      setTextChanged("normal");
    } else if (thisStyle === undefined || thisStyle === "normal") {
      list[i].fontStyle = "italic";
      obj.sous_images[i].fontStyle = "italic";
      setTextTranslated(list);
      console.log("style : ", obj);
      setSelectedTrans(obj);
      setTextChanged("italic");
    }
  };

  const strokeToggle = (i) => {
    //  document.getElementById(`stroke-${i}`).click();`
    setShowStroke(!showStroke);
    if (showStroke) {
      document.getElementById(`stroke-${i}`).style.display = "none";
    } else {
      document.getElementById(`stroke-${i}`).style.display = "block";
    }
  };

  const updateStroke = (event, i) => {
    let list = [...textTranslated];
    let obj = { ...transTextObject };
    let newvalue = event.target.value;
    const r = parseInt(newvalue.substring(1, 3), 16);
    const g = parseInt(newvalue.substring(3, 5), 16);
    const b = parseInt(newvalue.substring(5, 7), 16);
    list[i].stroke_color = `${r}, ${g}, ${b}`;
    obj.sous_images[i].stroke_color = `${r}, ${g}, ${b}`;
    setTextTranslated(list);
    console.log("stroke color : ", `${r}, ${g}, ${b}`);
    setSelectedTrans(obj);
    setSelectedIdx(i);
    setTextChanged(`${r}, ${g}, ${b}`);
  };

  function rgbToHex(rgbString) {
    // console.log('rgbToHex : ', rgbString)
    const [r, g, b] = rgbString
      .split(",")
      .map((num) => parseInt(num.trim(), 10));
    const hexColor = `#${((1 << 24) | (r << 16) | (g << 8) | b)
      .toString(16)
      .slice(1)
      .toUpperCase()}`;
    // console.log('rgbhexColor ', hexColor)
    return hexColor;
  }

  const onOffStroke = (stroke_applied, i) => {
    let obj = { ...transTextObject };
    obj.sous_images[i].stroke_applied = !stroke_applied;
    setShadowStyle({ ...shadowStyle, stroke_applied: !stroke_applied });
    console.log("onOffStroke : ", obj);
    setSelectedTrans(obj);
    // setSelectedIdx(i);
    // setTextChanged(newvalue);
    // setFonts(newvalue);
  };

  const updateStrokeColor = (event, i) => {
    let list = [...textTranslated];
    let obj = { ...transTextObject };
    let newvalue = event.target.value;
    const r = parseInt(newvalue.substring(1, 3), 16);
    const g = parseInt(newvalue.substring(3, 5), 16);
    const b = parseInt(newvalue.substring(5, 7), 16);
    list[i].stroke_color = `${r}, ${g}, ${b}`;
    obj.sous_images[i].stroke_color = `${r}, ${g}, ${b}`;
    setTextTranslated(list);
    console.log("stroke color : ", `${r}, ${g}, ${b}`);
    setShadowStyle({ ...shadowStyle, stroke_color: `${r}, ${g}, ${b}` });
    setSelectedTrans(obj);
    // setSelectedIdx(i)
    // setTextChanged(`${r}, ${g}, ${b}`);
  };

  const updateStrokeBlur = (event, i) => {
    // let list = [...transText];
    let obj = { ...transTextObject };
    let newvalue = event.target.value;
    // list[i].fontName = newvalue;
    obj.sous_images[i].stroke_blur = newvalue;
    // setTextTranslated(list);
    console.log("blur : ", obj);
    setShadowStyle({ ...shadowStyle, stroke_blur: newvalue });
    setSelectedTrans(obj);
    //  setSelectedIdx(i);
    //  setTextChanged(newvalue);
    // setFonts(newvalue);
  };

  const updateStrokeOpacity = (event, i) => {
    // let list = [...transText];
    let obj = { ...transTextObject };
    let newvalue = event.target.value;
    // list[i].fontName = newvalue;
    obj.sous_images[i].stroke_opacity = newvalue;
    // setTextTranslated(list);
    console.log("opacity : ", obj);
    setShadowStyle({ ...shadowStyle, stroke_opacity: newvalue });
    setSelectedTrans(obj);
    //  setSelectedIdx(i);
    //  setTextChanged(newvalue);
    // setFonts(newvalue);
  };

  const applyStroke = async (text, i) => {
    console.log("shadow applied : ", shadowStyle);
    console.log("shadow text : ", text);
    const token = localStorage.getItem("login_token");
    if (token && shadowStyle && text) {
      try {
        axios
          .put(
            `${process.env.REACT_APP_HOST_API}/api/translation/font/${text.id_sous_image}`,
            shadowStyle,
            {
              headers: { Authorization: token },
            }
          )
          .then((res) => {
            if (res.status === 200) {
              // if(text.traduction_validee === true){
              //   unvalidateText(text, i);
              // }
              // setSelectedIdx(null);
              if (text.traduction_validee === true) {
                unvalidateText(text, i);
              }
              console.log("res updated text : ", res);
              toast.success("stroke updated");
            }
          });
      } catch (error) {
        toast.error("shadow style invalid");
        console.log(error);
      }
    }
  };

  console.log("selected i : ", selectedIdx);
  console.log("shadow Style : ", shadowStyle);

  if (textTranslatedNew?.length !== 0 || textTranslated.length !== 0) {
    return (
      <>
        {(textTranslatedNew || textTranslated)?.map((e, i) => {
          return (
            <div
              key={i}
              className="texts_zone_content_cards"
              style={
                e?.traduction_validee
                  ? { border: "1.8px solid rgb(9, 214, 9)" }
                  : {}
              }
            >
              <div className="texts_zone_content_cards_header">
                <div className="ref">
                  {e.name_sous_image.split(".")[0].replace("_", "-")}
                </div>

                <div className="options">
                  <span
                    title="stroke"
                    className="fontStyle"
                    onClick={() => strokeToggle(i)}
                    style={{ color: e?.stroke_applied ? "red" : "" }}
                  >
                    |
                  </span>
                  <div
                    id={`stroke-${i}`}
                    className="stroke_section"
                    style={{ display: "none" }}
                  >
                    <div className="show_hide_stroke">
                      {e?.stroke_applied ? (
                        <IoIosEye
                          style={{ cursor: "pointer", color: "#dddddd" }}
                          onClick={() => onOffStroke(e?.stroke_applied, i)}
                          title="click to disable stroke"
                        />
                      ) : (
                        <IoIosEyeOff
                          style={{ cursor: "pointer", color: "#dddddd" }}
                          onClick={() => onOffStroke(e?.stroke_applied, i)}
                          title="click to enable stroke"
                        />
                      )}
                    </div>
                    <div className="stroke_color">
                      <span>color</span>
                      <input
                        title="stroke color"
                        type="color"
                        id={`stroke-color-${i}`}
                        value={rgbToHex(e?.stroke_color)}
                        onChange={(event) => updateStrokeColor(event, i)}
                      />
                      <div className="sub_block">
                        <span>width</span>
                        <input
                          title="stroke width"
                          type="range"
                          name="stroke_blur"
                          id="stroke_blur"
                          min={0}
                          step={0.1}
                          max={20}
                          value={e?.stroke_blur}
                          onChange={(event) => updateStrokeBlur(event, i)}
                        />
                      </div>
                    </div>
                    <div className="stroke_opacity">
                      <span>line height</span>
                      <input
                        title="stroke opacity"
                        type="range"
                        name="stroke_opacity"
                        id="stroke_opacity"
                        value={e?.stroke_opacity}
                        min={1}
                        max={4}
                        step={0.1}
                        onChange={(event) => updateStrokeOpacity(event, i)}
                      />
                    </div>
                    <div className="stroke_btn">
                      <button onClick={() => applyStroke(e, i)}>apply</button>
                    </div>
                  </div>

                  <select
                    name="fonts"
                    title="font family"
                    id="fonts"
                    className="fonts"
                    value={e?.fontName}
                    onChange={(event) => updateFont(event, i)}
                  >
                    <option value="Arial">Arial</option>
                    <option value="Poppins">Poppins</option>
                    <option value="Aladar">Aladar</option>
                    <option value="Komikula Bold">Komikula Bold</option>
                    <option value="Komikula">Komikula</option>
                    <option value="Wildjess">Wildjess</option>
                    <option value="Wildjess Italic">Wildjess Italic</option>
                    <option value="Boorsok">Boorsok</option>
                    <option value="Jester">Jester</option>
                    <option value="Palatino Linotype">Palatino Linotype</option>
                    <option value="Nafta">Nafta</option>
                    <option value="Satoshi italic">Satoshi italic</option>
                    <option value="Contour">Contour</option>
                    <option value="Komika boo">Komika boo</option>
                    <option value="Asmudila">Asmudila</option>
                    <option value="Fayuca">Fayuca</option>
                    <option value="Makasih">Makasih</option>
                    <option value="Geek a byte">Geek a byte</option>
                    <option value="Marker Monkey">Marker Monkey</option>
                    <option value="Koshari">Koshari</option>
                    <option value="Badaboom BB">Badaboom BB</option>
                    <option value="A Aha Wow">A Aha Wow</option>
                    <option value="Active">Active</option>
                  </select>

                  <input
                    className="size"
                    title="font size"
                    type="number"
                    name="size"
                    id="size"
                    min={0}
                    max={1000}
                    step={0.1}
                    value={e?.size}
                    onChange={(event) => updateSize(event, i)}
                  />

                  <select
                    name="weight"
                    id="weight"
                    title="font weight"
                    className="fonts"
                    value={e?.fontWeight}
                    onChange={(event) => updateWeight(event, i)}
                  >
                    <option value="lighter">lighter</option>
                    <option value="normal">normal</option>
                    <option value="bold">bold</option>
                    <option value="bolder">bolder</option>
                  </select>

                  <input
                    type="color"
                    id="color"
                    title="font color"
                    value={e?.color}
                    onChange={(event) => updateColor(event, i)}
                  />

                  <span
                    title="italic"
                    style={
                      e?.fontStyle === "italic"
                        ? { color: "red" }
                        : { color: "#898989" }
                    }
                    className="fontStyle"
                    onClick={() => changeFontStyle(i)}
                  >
                    i
                  </span>
                </div>
              </div>

              <div className="texts_zone_content_cards_body">
                <div className="text_O">{e.text_ocr || "No text detected"}</div>
                <textarea
                  className="text_T"
                  name="textTranslated"
                  id={`zone-${i}`}
                  value={e.text_translated}
                  onChange={(event) => updateTextTranslated(event, i)}
                />
                {e?.traduction_validee && (
                  <div className="validation_block">
                    <span className="validated_by">
                      Approved by {e?.fk_utilisateur_validation}
                    </span>
                    <span className="validated_at">
                      {e?.date_validation.split("T")[0]} at{" "}
                      {e?.date_validation.split("T")[1]?.split(":")[0]} :{" "}
                      {e?.date_validation.split("T")[1]?.split(":")[1]}
                    </span>
                  </div>
                )}
                <div className="btns">
                  <span
                    style={{ display: "none" }}
                    id={`v-spin-${i}`}
                    className="validating"
                    title="Validating..."
                  >
                    <AiOutlineLoading3Quarters />
                  </span>
                  <span
                    style={{ display: "none" }}
                    id={`updateText-${i}`}
                    onClick={() => updateText(e, i)}
                  ></span>
                  <span
                    className="valid"
                    id={`v-${i}`}
                    onClick={() => validateText(e, i)}
                    title="validate text"
                  >
                    <FaCheck />
                  </span>
                  <span
                    className={`comment ${
                      e?.comments?.commentaire ? "commentActive" : ""
                    }`}
                    id={`c-${i}`}
                    onClick={e?.comments?.commentaire ? null : showComments}
                    title="add comment"
                  >
                    <FaRegComment />
                  </span>
                </div>
                {e?.comments?.commentaire !== "" &&
                e?.comments?.commentaire !== null &&
                e?.comments?.commentaire !== undefined ? (
                  <div className="comments_exist" id={`comments_exist_${i}`}>
                    <div className="comments_exist_header">
                      <div className="group">
                        <div className="small_avatar">
                          {e?.comments?.commentaire_utilisateur[0]}
                        </div>
                        <div className="small_username">
                          @{e?.comments?.commentaire_utilisateur}
                        </div>
                      </div>
                      {e?.comments?.date_commentaire && (
                        <div className="comment_date">
                          {e?.comments?.date_commentaire.split("T")[0]} at{" "}
                          {
                            e?.comments?.date_commentaire
                              .split("T")[1]
                              ?.split(":")[0]
                          }{" "}
                          :{" "}
                          {
                            e?.comments?.date_commentaire
                              .split("T")[1]
                              ?.split(":")[1]
                          }
                        </div>
                      )}
                    </div>
                    <div className="comments_exist_body">
                      {e?.comments?.commentaire}
                    </div>
                    {loggedUser?.username ===
                      e?.comments?.commentaire_utilisateur && (
                      <div className="comments_exist_btns">
                        <span
                          style={{ display: "none" }}
                          id={`delete-spin-${i}`}
                          className="deleting"
                          title="Deleting..."
                        >
                          <AiOutlineLoading3Quarters />
                        </span>
                        <span
                          style={{ display: "block" }}
                          id={`delete-btn-${i}`}
                          title="Delete"
                          onClick={() =>
                            deleteComment(
                              e?.text_id,
                              e?.comments?.commentaire_fk_utilisateur,
                              i
                            )
                          }
                        >
                          <MdDelete />
                        </span>
                        <span
                          title="Edit"
                          onClick={() => updateComment(e?.comments, i)}
                        >
                          <MdEdit />
                        </span>
                      </div>
                    )}
                  </div>
                ) : (
                  ""
                )}
                <div className="add_comment d-none" id={`comment-${i}`}>
                  <textarea
                    name="comment"
                    id={`comment-${i}-value`}
                    placeholder="Add Comment..."
                  ></textarea>
                  <span
                    id={`send-comment-${i}`}
                    className="send_comment"
                    onClick={(event) => sendComment(event, i)}
                  >
                    <BsFillSendFill />
                  </span>
                  <span
                    id={`send-comment-spin-${i}`}
                    className="send_comment send_loading dis-none"
                  >
                    <AiOutlineLoading3Quarters />
                  </span>
                </div>
                <div className="add_comment d-none" id={`update-comment-${i}`}>
                  <textarea
                    name="comment"
                    id={`update-comment-${i}-value`}
                    placeholder="Add Comment..."
                  ></textarea>
                  <span
                    id={`send-update-comment-${i}`}
                    className="send_comment"
                    onClick={(event) => sendUpdatedComment(event, i)}
                  >
                    <BsFillSendFill />
                  </span>
                  <span
                    id={`send-update-comment-spin-${i}`}
                    className="send_comment send_loading dis-none"
                  >
                    <AiOutlineLoading3Quarters />
                  </span>
                </div>
              </div>
            </div>
          );
        })}
        {/* {(allTextsValid || allTextsAreValid) && <button className='validate_page' type="button" onClick={validateThisPage}>{validationText}</button>} */}
      </>
    );
  }
};

export default TextZone;
